import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Paginator} from 'front-onceforall-core';
import Reminder from './reminder';
import {useSubcontractorDetailsStore} from '../SubcontractorDetailsStore';

function DocumentRemindersView(props) {
  const {state: {reminders: {list, loading, error, totalCount, pageSize}}} = useSubcontractorDetailsStore();

  if (error) {
    return (
      <div className="table-without-result">
        <Translate value="error.generic"/>
      </div>
    );
  }

  return (
    <div>
      {loading && <div className="loading-overlay"/>}
      {totalCount === 0 ?
        <div className="card table-without-result">
          <Translate value="document.remind.description.emptyMessage"/>
        </div> :
        <div>
          {list.map(reminder => (
            <Reminder
              key={reminder.id}
              reminder={reminder}
            />
          ))}
          <div className="mt-5 mb-4">
            <Paginator
              totalItems={totalCount}
              pageSize={pageSize}
              currentPage={props.pageNumber}
              onChangePage={props.onPageChange}
            />
          </div>
        </div>
      }
    </div>
  );
}

DocumentRemindersView.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

export default DocumentRemindersView;
